export default __webpack_public_path__ + "static/media/cv.065fcf3c.svg";